export enum ClientCategory {
  Buyer = 'Buyer',
  Seller = 'Seller',
  Both = 'Both',
  Retention = 'Retention',
}
